module.exports = __webpack_public_path__ + "img/hero.88f97865.jpg";